"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_actions_1 = require("redux-actions");
var Types_1 = require("./Types");
exports.menuNavigationAction = redux_actions_1.createAction(Types_1.MENU_NAVIGATION, function (item) {
    return { id: item.id, title: item.title, pathname: item.pathname };
});
//# sourceMappingURL=Action.js.map